import { render, staticRenderFns } from "./CustomersAdd.vue?vue&type=template&id=1fc9692e&"
import script from "./CustomersAdd.vue?vue&type=script&lang=js&"
export * from "./CustomersAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports